<ng-container *ngVar="(communitiesRD$ | async) as communitiesRD">
  <div *ngIf="communitiesRD?.hasSucceeded ">
    <h2>
      {{'home.top-level-communities.head' | translate}}
    </h2>
  <p class="lead">{{'home.top-level-communities.help' | translate}}</p>

  <!-- top-level community grid -->
  <mat-grid-list [cols]="cols" rowHeight="300px" gutterSize="5px" #topLevelCommunityGridList>
    <mat-grid-tile *ngFor="let topLevelCommunity of topLevelCommunities">
      <ds-top-level-community-item [community]="topLevelCommunity"></ds-top-level-community-item>
    </mat-grid-tile>
  </mat-grid-list>

</div>
<ds-error *ngIf="communitiesRD?.hasFailed " message="{{'error.top-level-communites' | translate}}"></ds-error>
<ds-themed-loading *ngIf="communitiesRD?.isLoading " message="{{'loading.top-level-communities' | translate}}"></ds-themed-loading></ng-container>
